import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cafe-resto-monastir',
  templateUrl: './cafe-resto-monastir.component.html',
  styleUrls: ['./cafe-resto-monastir.component.scss']
})
export class CafeRestoMonastirComponent implements OnInit {
 
  public coffeMonastir: any
  p: Number = 1;
  closeResult = '';
  public agencies: any
  search_name1: any;
  dataSource = new MatTableDataSource();
  public search: string = ''
  constructor(private agenciesService:AgenciesService,private searchService: SearchService) { }

  ngOnInit(): void {
    this.cafeeMonastir();

  }
  cafeeMonastir() {
this.agenciesService.getList().subscribe((data:any)=>{
  this.coffeMonastir = data
  this.agencies = this.coffeMonastir.filter((data:any)=>{
return data.region === 'monastir' && data.phone_number_commercial === 'yes'
  })
})
  }
  performSearch() {
    this.coffeMonastir = this.searchService.search(this.coffeMonastir, this.search);
  }
  deleteAgencies(agencie, i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          this.coffeMonastir.splice(i, 1)

          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
          // setTimeout(() => {
          //   this.getagencesTunis();
          // }, 500);

        });
      }
    });
  }

}
